import BaseService from './BaseService'

class PermissionService extends BaseService {

  constructor () {
    super({path: 'permissions'})
  }
}

export default new PermissionService()
